import { useMutation, useQueryCache } from 'react-query';
import { WebsiteMessageAPI } from 'api/websiteMessage';
import { WEBSITE_MESSAGES } from 'helpers/constants';
import dispatchToast from 'helpers/dispatchToast';

export default function useUpdateWebsiteMessage() {
  const queryCache = useQueryCache();

  return useMutation(WebsiteMessageAPI.update, {
    onSuccess: ({ message }, { onSuccess = () => {} }) => {
      queryCache.invalidateQueries(WEBSITE_MESSAGES);
      dispatchToast({ message, type: 'success' });
      onSuccess();
    },
  });
}
